import React from 'react'

import { CollegeDetail } from 'store/prospects/type-definitions'

export type StudentInfo = {
  firstName: string
  lastName: string
  email: string
  dateOfBirth: string
  phoneNumber?: string
  academicFocuses?: string[]
}

export type DOBError = { hasError: false } | { hasError: true; reason: 'invalid-date' | 'under-13' }

export type ErrorDetails = {
  firstName: boolean
  lastName: boolean
  email: boolean
  phoneNumber: boolean
  dateOfBirth: DOBError
}

interface Context {
  handleOpen: () => void
  handleClose: () => void
  handleDismiss: () => void
  handleAfterClose: () => void
  open: boolean
  selectedCollege: CollegeDetail | null
  selectCollege: (college: CollegeDetail | null, referrer?: string, callback?: () => void) => void
  handleSave: () => void
  isSaving?: boolean
  errors?: ErrorDetails
  updateStudentInterestInfo: (field: keyof StudentInfo, value: StudentInfo[keyof StudentInfo]) => void
  studentInterestInfo?: StudentInfo
  requiredFieldsIncomplete?: boolean
  preferenceTypeSet: boolean
  preferenceType?: 'share_with_all_colleges' | 'ask_me_every_time'
  setPreferenceType: (type: 'share_with_all_colleges' | 'ask_me_every_time') => void
  firstTime?: boolean
}
const ctx: Context = {
  handleOpen: () => {},
  handleClose: () => {},
  handleDismiss: () => {},
  handleAfterClose: () => {},
  open: false,
  selectedCollege: null,
  selectCollege: () => {},
  handleSave: () => {},
  updateStudentInterestInfo: () => {},
  preferenceTypeSet: false,
  setPreferenceType: () => {},
}
const ShareInterestContext = React.createContext(ctx)
export default ShareInterestContext
